module.exports = __webpack_public_path__ + "8c533adfe868b5419775a10b0498a3fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/teachers-picks.png
// module id = 190
// module chunks = 0